"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysBetweenAdmissionAndPolicyEndDates = exports.checkCrossoverAndUpdateLocs = exports.isCrossoverTriggered = exports.getTotalLosDaysForCrossoverTrigger = exports.checkCrossover = exports.UpdateSelectedFacilityLocs = exports.BuildSelectedLevelsofCare = exports.updateRateLosByQuoteMethod = exports.sortNewFacilityLevelOfCare = exports.sortFacilityLevelOfCare = exports.getFacilityLevelsOfCareSummary = exports.getRateAndLosFromQuoteMethod = void 0;
var utils_1 = require("../../../utils/utils");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var getRateAndLosFromQuoteMethod = function (loc, quoteMethod, inNetwork) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var returnData = {
        pdrRate: 0,
        losDays: 0,
    };
    // first use thirdparty (master list) rate and los
    if (inNetwork) {
        returnData.losDays = loc.thirdPartyAverageInnLos
            ? loc.thirdPartyAverageInnLos
            : 0;
        returnData.pdrRate = loc.thirdPartyAverageInnPdr
            ? loc.thirdPartyAverageInnPdr
            : 0;
    }
    else {
        returnData.losDays = loc.thirdPartyAverageOnnLos
            ? loc.thirdPartyAverageOnnLos
            : 0;
        returnData.pdrRate = loc.thirdPartyAverageOnnPdr
            ? loc.thirdPartyAverageOnnPdr
            : 0;
    }
    // then try to find rate and los data using quotemethod
    switch (quoteMethod) {
        case 'avglos':
            if ((_a = loc.facilityPayorLocRateLos) === null || _a === void 0 ? void 0 : _a.pdrRate) {
                returnData.pdrRate = (_b = loc.facilityPayorLocRateLos) === null || _b === void 0 ? void 0 : _b.pdrRate;
            }
            if ((_c = loc.facilityPayorLocRateLos) === null || _c === void 0 ? void 0 : _c.losDays) {
                returnData.losDays = (_d = loc.facilityPayorLocRateLos) === null || _d === void 0 ? void 0 : _d.losDays;
            }
            break;
        case 'sca':
            returnData.pdrRate = (_e = loc.scaRatesLos) === null || _e === void 0 ? void 0 : _e.pdrRate;
            returnData.losDays = (_f = loc.scaRatesLos) === null || _f === void 0 ? void 0 : _f.losDays;
            break;
        case 'rlos':
            if ((_g = loc.facilityPayorLocRateLos) === null || _g === void 0 ? void 0 : _g.pdrRate) {
                returnData.pdrRate = (_h = loc.facilityPayorLocRateLos) === null || _h === void 0 ? void 0 : _h.pdrRate;
            }
            if ((_j = loc.facilityLocRlos) === null || _j === void 0 ? void 0 : _j.losDays) {
                returnData.losDays = loc.facilityLocRlos.losDays;
            }
            break;
        case 'manual':
            returnData.losDays = (_k = loc.manualRatesLos) === null || _k === void 0 ? void 0 : _k.losDays;
            returnData.pdrRate = (_l = loc.facilityPayorLocRateLos) === null || _l === void 0 ? void 0 : _l.pdrRate;
            break;
        default:
            throw new Error('Missing Quote Method');
    }
    return returnData;
};
exports.getRateAndLosFromQuoteMethod = getRateAndLosFromQuoteMethod;
var getFacilityLevelsOfCareSummary = function (selectedLevelsOfCare, quoteMethod, inNetwork, isSelfPay) {
    var levelsOfCareSummary = [];
    var isCovered = false;
    selectedLevelsOfCare.forEach(function (loc) {
        var locLosRate = (0, exports.getRateAndLosFromQuoteMethod)(loc, quoteMethod, inNetwork);
        var locType = (loc === null || loc === void 0 ? void 0 : loc.cfgLocType) ? loc.cfgLocType : 0;
        if (locType === 0 &&
            (loc === null || loc === void 0 ? void 0 : loc.facilityPayorLocRateLos).isCovered) {
            isCovered = (loc === null || loc === void 0 ? void 0 : loc.facilityPayorLocRateLos)
                .isCovered;
        }
        else {
            isCovered = false;
        }
        levelsOfCareSummary.push({
            code: loc.facilityLevelOfCareCode,
            name: loc.facilityLevelOfCareName,
            days: locLosRate.losDays ? locLosRate.losDays : 0,
            rate: locLosRate.pdrRate || 0,
            vobClassificationId: loc === null || loc === void 0 ? void 0 : loc.vobClassificationId,
            covered: isSelfPay ? false : isCovered,
            cfgLocType: locType,
            cfgLocCode: loc === null || loc === void 0 ? void 0 : loc.cfgLevelOfCareId,
            facilityId: loc === null || loc === void 0 ? void 0 : loc.clientFacilityId,
        });
    });
    return levelsOfCareSummary;
};
exports.getFacilityLevelsOfCareSummary = getFacilityLevelsOfCareSummary;
var sortFacilityLevelOfCare = function (facilityLoc) {
    // sorts by sortOrder first, items without sortOrder follow sorted alphabetically
    var locNameA = '';
    var locNameB = '';
    var returnArr = [];
    var sortableLoc = [];
    var unSortableLoc = [];
    facilityLoc.forEach(function (loc) {
        if (loc.sortOrder)
            sortableLoc.push(loc);
        if (!loc.sortOrder)
            unSortableLoc.push(loc);
    });
    if (sortableLoc.length > 0) {
        sortableLoc.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
        });
        returnArr = __spreadArray(__spreadArray([], returnArr, true), sortableLoc, true);
    }
    if (unSortableLoc.length > 0) {
        unSortableLoc.sort(function (a, b) {
            locNameA = a.facilityLevelOfCareName
                ? a.facilityLevelOfCareName.toLowerCase()
                : '';
            locNameB = b.facilityLevelOfCareName
                ? b.facilityLevelOfCareName.toLowerCase()
                : '';
            return locNameA < locNameB ? -1 : locNameA > locNameB ? 1 : 0;
        });
        returnArr = __spreadArray(__spreadArray([], returnArr, true), unSortableLoc, true);
    }
    return returnArr;
};
exports.sortFacilityLevelOfCare = sortFacilityLevelOfCare;
var sortNewFacilityLevelOfCare = function (facilityLoc) {
    // sorts by sortOrder first, items without sortOrder follow sorted alphabetically
    var locNameA = '';
    var locNameB = '';
    var returnArr = [];
    var sortableLoc = [];
    var unSortableLoc = [];
    facilityLoc.forEach(function (loc) {
        if (loc.sortOrder)
            sortableLoc.push(loc);
        if (!loc.sortOrder)
            unSortableLoc.push(loc);
    });
    if (sortableLoc.length > 0) {
        sortableLoc.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
        });
        returnArr = __spreadArray(__spreadArray([], returnArr, true), sortableLoc, true);
    }
    if (unSortableLoc.length > 0) {
        unSortableLoc.sort(function (a, b) {
            locNameA = a.facilityLevelOfCareName
                ? a.facilityLevelOfCareName.toLowerCase()
                : '';
            locNameB = b.facilityLevelOfCareName
                ? b.facilityLevelOfCareName.toLowerCase()
                : '';
            return locNameA < locNameB ? -1 : locNameA > locNameB ? 1 : 0;
        });
        returnArr = __spreadArray(__spreadArray([], returnArr, true), unSortableLoc, true);
    }
    return returnArr;
};
exports.sortNewFacilityLevelOfCare = sortNewFacilityLevelOfCare;
var updateRateLosByQuoteMethod = function (loc, quoteMethod, value, rate) {
    switch (quoteMethod) {
        case 'avglos':
            if (rate) {
                loc.facilityPayorLocRateLos.pdrRate = value;
            }
            else {
                loc.facilityPayorLocRateLos.losDays = value;
            }
            break;
        case 'sca':
            if (rate) {
                loc.scaRatesLos.pdrRate = value;
            }
            else {
                loc.scaRatesLos.losDays = value;
            }
            break;
        case 'rlos':
            if (rate) {
                loc.facilityPayorLocRateLos.pdrRate = value;
            }
            else {
                loc.facilityLocRlos.losDays = value;
            }
            break;
        case 'manual':
            if (rate) {
                loc.facilityPayorLocRateLos.pdrRate = value;
            }
            else {
                loc.manualRatesLos.losDays = value;
            }
            break;
        default:
        // nothing
    }
    if (rate) {
        if (loc.selectedRateLos) {
            loc.selectedRateLos.pdrRate = value;
        }
    }
    else {
        if (loc.selectedRateLos) {
            loc.selectedRateLos.losDays = value;
        }
    }
    return loc;
};
exports.updateRateLosByQuoteMethod = updateRateLosByQuoteMethod;
var BuildSelectedLevelsofCare = function (facilityLocList, facilityId, quoteMethod, inNetwork, selfPay) {
    var clientLevelsOfCareFilteredByFacilityId = facilityLocList.filter(function (cloc) { return cloc.clientFacilityId === facilityId; });
    var sortedFacilityLocList = (0, exports.sortFacilityLevelOfCare)(clientLevelsOfCareFilteredByFacilityId);
    var facilityLocs = [];
    sortedFacilityLocList.forEach(function (loc) {
        var _a, _b, _c, _d;
        var locCopy = utils_1.Utils.deepClone(loc);
        var ratesLos = (0, exports.getRateAndLosFromQuoteMethod)(locCopy, quoteMethod, inNetwork);
        locCopy.manualRatesLos = {
            pdrRate: (_a = ratesLos.pdrRate) !== null && _a !== void 0 ? _a : 0,
            losDays: 0,
        };
        locCopy.scaRatesLos = {
            pdrRate: 0,
            losDays: 0,
        };
        locCopy.selectedRateLos = {
            pdrRate: (_b = ratesLos.pdrRate) !== null && _b !== void 0 ? _b : 0,
            losDays: (_c = ratesLos.losDays) !== null && _c !== void 0 ? _c : 0,
        };
        if (selfPay) {
            if ((_d = locCopy === null || locCopy === void 0 ? void 0 : locCopy.facilityPayorLocRateLos) === null || _d === void 0 ? void 0 : _d.isCovered) {
                locCopy.facilityPayorLocRateLos.isCovered = false;
            }
        }
        if (!locCopy.facilityLevelOfCareCode) {
            locCopy.facilityLevelOfCareCode = '';
        }
        if (!locCopy.facilityLevelOfCareName) {
            locCopy.facilityLevelOfCareName = '';
        }
        facilityLocs.push(locCopy);
    });
    return facilityLocs;
};
exports.BuildSelectedLevelsofCare = BuildSelectedLevelsofCare;
var UpdateSelectedFacilityLocs = function (selectedFacilityLocs, facilityLocs) {
    var selectedFacilityLocsCopy = [];
    selectedFacilityLocs.forEach(function (loc) {
        var sourceLocIdx = facilityLocs.findIndex(function (facLoc) { return loc.cfgLevelOfCareId === facLoc.cfgLevelOfCareId; });
        if (sourceLocIdx > -1) {
            var locCopy = utils_1.Utils.deepClone(loc);
            if (!locCopy.facilityLocRlos) {
                locCopy.facilityLocRlos =
                    facilityLocs[sourceLocIdx].facilityLocRlos;
            }
            if (!locCopy.manualRatesLos) {
                locCopy.manualRatesLos =
                    facilityLocs[sourceLocIdx].manualRatesLos;
            }
            if (!locCopy.selectedRateLos) {
                locCopy.selectedRateLos =
                    facilityLocs[sourceLocIdx].selectedRateLos;
            }
            if (!locCopy.scaRatesLos) {
                locCopy.scaRatesLos = facilityLocs[sourceLocIdx].scaRatesLos;
            }
            selectedFacilityLocsCopy.push(locCopy);
        }
    });
    return selectedFacilityLocsCopy;
};
exports.UpdateSelectedFacilityLocs = UpdateSelectedFacilityLocs;
var checkCrossover = function (value, admissionDate, policyEndDate) {
    var admissionDateCopy = new Date(admissionDate);
    admissionDateCopy.setDate(admissionDateCopy.getDate() + value - 1);
    return admissionDateCopy > policyEndDate;
};
exports.checkCrossover = checkCrossover;
var getTotalLosDaysForCrossoverTrigger = function (selectedLocs) {
    var doesOutpatientLOCExist = false;
    var totalLosDays = selectedLocs.reduce(function (acc, selectedLoc) {
        var isLocOutpatient = selectedLoc.locType !== 1 ? !selectedLoc.isInpatient : false;
        if (isLocOutpatient)
            doesOutpatientLOCExist = true;
        acc += selectedLoc.locType !== 1 ? selectedLoc.losDays : 0;
        return acc;
    }, 0);
    return {
        totalLosDays: totalLosDays,
        doesOutpatientLOCExist: doesOutpatientLOCExist
    };
};
exports.getTotalLosDaysForCrossoverTrigger = getTotalLosDaysForCrossoverTrigger;
var isCrossoverTriggered = function (_a) {
    var selectedLocs = _a.selectedLocs, admissionDate = _a.admissionDate, policyEndDate = _a.policyEndDate;
    var _b = (0, exports.getTotalLosDaysForCrossoverTrigger)(selectedLocs), totalLosDays = _b.totalLosDays, doesOutpatientLOCExist = _b.doesOutpatientLOCExist;
    //Check if total los days of all LOCs (except surcharges) trigger crossover
    var doesTotalLOSDaysTriggerCrossover = (0, exports.checkCrossover)(totalLosDays, admissionDate, policyEndDate);
    /**
     * Check if outpatient LOC exists, and if the total number of days until the policy end date is less than 60 days.
     * Crossover should be triggered at 60 days
     * */
    var does60DaysTriggerCrossover = (0, exports.checkCrossover)(60, admissionDate, policyEndDate);
    return doesTotalLOSDaysTriggerCrossover || (doesOutpatientLOCExist && does60DaysTriggerCrossover);
};
exports.isCrossoverTriggered = isCrossoverTriggered;
var checkCrossoverAndUpdateLocs = function (_a) {
    var selectedLocs = _a.selectedLocs, admissionDate = _a.admissionDate, policyEndDate = _a.policyEndDate;
    var isCrossover = (0, exports.isCrossoverTriggered)({
        selectedLocs: selectedLocs,
        admissionDate: admissionDate,
        policyEndDate: policyEndDate
    });
    var newSelectedLocs;
    if (isCrossover) {
        newSelectedLocs = selectedLocs.map(function (loc) {
            return __assign(__assign(__assign({}, loc), loc.hasOwnProperty("losDaysBeforeCrossover") ? { losDaysBeforeCrossover: loc.losDaysBeforeCrossover } : loc.locType === 1 ? { losDaysBeforeCrossover: 0 } : {}), loc.hasOwnProperty("losDaysAfterCrossover") ? { losDaysAfterCrossover: loc.losDaysAfterCrossover } : loc.locType === 1 ? { losDaysAfterCrossover: loc.losDays } : {});
        });
    }
    else {
        newSelectedLocs = selectedLocs.map(function (loc) {
            return lodash_1.default.omit(loc, ["losDaysBeforeCrossover", "losDaysAfterCrossover"]);
        });
    }
    return {
        isCrossover: isCrossover,
        newSelectedLocs: newSelectedLocs
    };
};
exports.checkCrossoverAndUpdateLocs = checkCrossoverAndUpdateLocs;
var getDaysBetweenAdmissionAndPolicyEndDates = function (_a) {
    var admissionDate = _a.admissionDate, policyEndDate = _a.policyEndDate;
    var policyEndDateMoment = (0, moment_1.default)(policyEndDate);
    var admissionDateMoment = (0, moment_1.default)(admissionDate);
    return Math.max(policyEndDateMoment.diff(admissionDateMoment, 'days')
        + 1, //policyEndDate is inclusive
    0);
};
exports.getDaysBetweenAdmissionAndPolicyEndDates = getDaysBetweenAdmissionAndPolicyEndDates;
